module.exports = __webpack_public_path__ + "img/25.f49d3c8c.jpg";